import type { StudentAttributes } from '@backend/agents-ui-api/resources/students/types'
import type { UpdateStudentResponse } from '@backend/agents-ui-api/routes/students/{studentId}/PATCH/types'

import { ApiAgentRequest, request } from '../utils'

import { useAuthMutation } from './auth'

type UpdateStudentParams = {
  id: string
  attributes?: StudentAttributes
}

export function useUpdateStudent() {
  const { isPending, mutate } = useAuthMutation(async (params: UpdateStudentParams) => {
    return request<UpdateStudentResponse>(
      new ApiAgentRequest(`/students/${params.id}`, {
        method: 'PATCH',
        body: {
          data: {
            id: params.id,
            type: 'student',
            attributes: params.attributes,
          },
        },
      }),
      {
        isExpectedResponse: (res): res is UpdateStudentResponse => res as boolean,
      },
    )
  })

  return {
    isUpdatingStudent: isPending,
    updateStudent: mutate,
  }
}